function input_box(){
  // Native discount code input handling
  document.addEventListener('keydown', function(e){
    if(e.target.matches('.cd-discount-input') && e.key === 'Enter'){
      e.preventDefault();
    }
  });
  document.addEventListener('keyup', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap){
        if(e.target.value !== ''){
          wrap.classList.add('active-input');
        } else {
          wrap.classList.remove('active-input');
        }
      }
      if(e.key === 'Enter'){
        e.preventDefault();
        var applyBtn = e.target.closest('.cd-discount-form').querySelector('.cd-discount-apply');
        if(applyBtn && !applyBtn.disabled) applyBtn.click();
      }
    }
  });
  document.addEventListener('focus', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap) wrap.classList.add('active-focus');
    }
  }, true);
  document.addEventListener('blur', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap) {
        var form = e.target.closest('.cd-discount-form');
        var msg = form && form.querySelector('.cd-discount-message');
        var btn = form && form.querySelector('.cd-discount-apply');
        var isLoading = btn && btn.classList.contains('loading');
        var hasError = msg && msg.classList.contains('error');
        var hasText = e.target.value !== '';
        if(!isLoading && !hasError && !hasText) {
          wrap.classList.remove('active-focus');
        }
      }
    }
  }, true);
  if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    menuBurger.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      document.body.classList.toggle('open-menu');
      document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');    
    });
  });
}
function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
      updateItem(new_line, new_qty);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(centerQtyInput.value);
      if(currentQty > 0){
        centerQtyInput.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        updateItem(newLine, newQty);
      }
    });
  });
  document.querySelectorAll('.inactive .cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.item-row').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.item-row').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.item-row').querySelector('.cart_qty').value;
      let formData = {
        'items': [{'id': changevar_id,'quantity': item_current_qty}]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        setTimeout(function(e){
          updateItem(currentid,0);
        },500);
      })
      .catch((error) => {
        console.error('error',error);
        cart_error.text(e.responseJSON.description);
        setTimeout(function(){
          cart_error.text('');
        },2000);
      });
    })
  })
  // if(document.querySelectorAll(".cd_variant_cls")) document.querySelectorAll(".cd_variant_cls").forEach((variantBox) => {
  //   let btn = variantBox.querySelector(".cd_variantbtn");
  //   if(btn) btn.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     e.stopImmediatePropagation();
  //     document.querySelectorAll('.item-row').forEach((variantBoxRm) => {
  //       variantBoxRm.querySelector(".cd_variant_cls").classList.remove("active");
  //     });
  //     variantBox.classList.add("active");
  //   });
  // });
  if (document.querySelectorAll(".cd_variant_cls")) {
    document.querySelectorAll(".cd_variant_cls").forEach((variantBox) => {
      let btn = variantBox.querySelector(".cd_variantbtn");
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          document.querySelectorAll(".item-row").forEach((variantBoxRm) => {
            variantBoxRm.querySelector(".cd_variant_cls").classList.remove("active");
          });

          variantBox.classList.add("active");

          let dropdown = variantBox.querySelector(".cd__variant_list");
          let scrollParent = document.querySelector(".cd-left");

          if (dropdown && scrollParent) {
            setTimeout(() => {
              let dropdownBottom = dropdown.getBoundingClientRect().bottom;
              let parentBottom = scrollParent.getBoundingClientRect().bottom;

              if (dropdownBottom > parentBottom) {
                let scrollAmount = dropdownBottom - parentBottom + 24; // +24px offset
                scrollParent.scrollBy({
                  top: scrollAmount,
                  behavior: "smooth"
                });
              }
            }, 310);
          }
        });
      }
    });
  }

  if(document.querySelectorAll(".cd-varinat-close,.variant-overlay-box")) document.querySelectorAll(".cd-varinat-close,.variant-overlay-box").forEach((variantBoxClose) => {
    variantBoxClose.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      variantBoxClose.closest('.cart-sidebar').querySelector('.cd_variant_cls.active').classList.remove("active");
    });
  });

  if(document.querySelectorAll('.gift-product li .ellipse-icon')) document.querySelectorAll('.gift-product li .ellipse-icon').forEach((ellipse) => {
    ellipse.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelectorAll('.gift-product li').forEach((ellipserm) => {
        ellipserm.querySelector('.gp-left').classList.remove('active-tooltip');
      });
      ellipse.closest('.gp-left').classList.add('active-tooltip');
    });
  });
  if(document.querySelectorAll('.gift-product li .tooltip p a')) document.querySelectorAll('.gift-product li .tooltip p a').forEach((ellipse_close) => {
    ellipse_close.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      ellipse_close.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  document.body.addEventListener('click', function () {
    document.querySelectorAll('.gift-product li .tooltip').forEach(function (tooltip){
      tooltip.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  announcebar({
    container: '.product-usps',
    duration: 3000
  });
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  document.querySelectorAll(".item-list .item-row").forEach((cItem) => {
    const id = cItem.dataset.id;
    document.querySelectorAll(".gift-product input").forEach((input) => {
      if(input.value === id){
        input.checked = true;
        togglePriceVisibility(input, true);
      }
    });
  });
  document.querySelectorAll(".gift-product input").forEach((input) => {
    input.addEventListener("change", function(e){
      if(input.checked){
        addItemNew(input.value);
        togglePriceVisibility(input, true);
      }else{
        updateItem(input.value,0);
        togglePriceVisibility(input, false);
      }
    });
  });
  function addItemNew(line){
    const data = {
      items:[{id: line,quantity: 1,},],
    };
    fetch("/cart/add.js",{
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then(() => {
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
}
// Discount code helpers
function fetchCurrentDiscountCodes() {
  return fetch('/cart.js', { method: 'GET' })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var codes = [];
      if(data.cart_level_discount_applications) {
        data.cart_level_discount_applications.forEach(function(d) {
          if(d.type === 'discount_code') codes.push(d.title);
        });
      }
      if(data.items) {
        data.items.forEach(function(item) {
          if(item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
            item.line_level_discount_allocations.forEach(function(d) {
              if(d.discount_application && d.discount_application.type === 'discount_code') {
                codes.push(d.discount_application.title);
              }
            });
          }
        });
      }
      return codes.filter(function(v, i, a) { return a.indexOf(v) === i; });
    });
}
function setDiscountLoading(loading) {
  var btn = document.querySelector('.cd-discount-apply');
  if(!btn) return;
  if(loading) {
    btn.disabled = true;
    btn.classList.add('loading');
  } else {
    btn.disabled = false;
    btn.classList.remove('loading');
  }
}
function applyDiscountCode(code) {
  fetchCurrentDiscountCodes().then(function(codes) {
    var msgEl = document.querySelector('.cd-discount-message');
    if(codes.map(function(c){return c.toLowerCase();}).indexOf(code.toLowerCase()) !== -1) {
      if(msgEl) { msgEl.textContent = 'Discount code already applied.'; msgEl.className = 'cd-discount-message error'; }
      setDiscountLoading(false);
      return;
    }
    codes.push(code);
    fetch('/checkout?discount=' + codes.map(encodeURIComponent).join(','), { method: 'GET' })
    .finally(function() {
      fetch('/cart.js', { method: 'GET' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var applied = [];
        if(data.cart_level_discount_applications) {
          data.cart_level_discount_applications.forEach(function(d) {
            if(d.type === 'discount_code') applied.push(d.title);
          });
        }
        if(data.items) {
          data.items.forEach(function(item) {
            if(item.line_level_discount_allocations) {
              item.line_level_discount_allocations.forEach(function(d) {
                if(d.discount_application && d.discount_application.type === 'discount_code') {
                  applied.push(d.discount_application.title);
                }
              });
            }
          });
        }
        var freshMsg = document.querySelector('.cd-discount-message');
        var freshInput = document.querySelector('.cd-discount-input');
        if(applied.map(function(c){return c.toLowerCase();}).indexOf(code.toLowerCase()) === -1) {
          if(freshMsg) { freshMsg.textContent = 'Enter a valid discount code or gift card.'; freshMsg.className = 'cd-discount-message error'; }
          setDiscountLoading(false);
        } else {
          if(freshInput) freshInput.value = '';
          if(typeof load_cart === 'function') load_cart();
        }
      });
    });
  });
}
function removeDiscountCode(code) {
  var badge = document.querySelector('.cd-discount-badge[data-code="' + code + '"]') || document.querySelector('.cd-discount-remove[data-code="' + code + '"]');
  if(badge) badge.style.opacity = '0.4';
  fetchCurrentDiscountCodes().then(function(codes) {
    var remaining = codes.filter(function(c) { return c.toLowerCase() !== code.toLowerCase(); });
    fetch('/checkout?discount=' + remaining.map(encodeURIComponent).join(','), { method: 'GET' })
    .finally(function() {
      if(typeof load_cart === 'function') load_cart();
    });
  });
}
// Discount code handlers — event-delegated so they always work after DOM reloads
document.addEventListener('click', function(e) {
  var discountToggle = e.target.closest('.add_discount');
  if(discountToggle) {
    e.preventDefault();
    var wrapper = discountToggle.closest('.cd-discount-wrapper');
    if(wrapper) {
      wrapper.classList.add('active-discount');
      var inp = wrapper.querySelector('.cd-discount-input');
      if(inp) inp.focus();
    }
    return;
  }
  var applyBtn = e.target.closest('.cd-discount-apply');
  if(applyBtn) {
    e.preventDefault();
    var form = applyBtn.closest('.cd-discount-form');
    var input = form.querySelector('.cd-discount-input');
    var msgEl = form.querySelector('.cd-discount-message');
    var code = input.value.trim();
    if(msgEl) { msgEl.textContent = ''; msgEl.className = 'cd-discount-message'; }
    if(!code) {
      if(msgEl) { msgEl.textContent = 'Enter a valid discount code or gift card.'; msgEl.className = 'cd-discount-message error'; }
      return;
    }
    setDiscountLoading(true);
    applyDiscountCode(code);
    return;
  }
  var removeBtn = e.target.closest('.cd-discount-remove');
  if(removeBtn) {
    e.preventDefault();
    removeDiscountCode(removeBtn.dataset.code);
    return;
  }
});
// Helper function to get price element for gift products
function getPriceElementForInput(input) {
  // Try multiple strategies to find the price element
  const listItem = input.closest('li');
  if (!listItem) return null;
  // Primary selector
  let priceElement = listItem.querySelector('.gp-rgt');
  return priceElement;
}
// Helper function to toggle gift products price visibility
function togglePriceVisibility(input, show) {
  const priceElement = getPriceElementForInput(input);
  if (priceElement) {
    priceElement.style.display = show ? 'block' : 'none';
  } else {
    console.warn('Price element not found for input');
  }
}

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer&_=' + Date.now())
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => updateItem(data_line,0));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector('body').classList.toggle('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        input_box();
      });
    });
    function overlay(){
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
          createdUlElements.forEach(ul => ul.remove());
          if(document.querySelector('body').classList.contains('open-quick-buy') && document.querySelector('body').classList.contains('open-drawer')){
            document.querySelector('body').classList.remove('open-quick-buy','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }else{
            document.querySelector('body').classList.remove('open-quick-buy','open-drawer','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }
          document.querySelector('localization-form').classList.remove('active');
        });
      });
    }
    function singleCartDrawerClose() {
      const cartDrawerCloseButtons = document.querySelectorAll('.cart-drawer-close');
      if (cartDrawerCloseButtons.length > 0) {
        cartDrawerCloseButtons.forEach((cartDrawerClose) => {
          cartDrawerClose.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const body = document.querySelector('body');
            body.classList.remove(
              'open-quick-buy',
              'open-drawer',
              'open-menu',
              'open-search',
              'open-sort',
              'open-filter',
              'open-mobile-search',
              'filter-sticky',
              'active-wishli-pro',
              'open-size-chart'
            );
            const localizationForm = document.querySelector('localization-form');
            if (localizationForm) {
              localizationForm.classList.remove('active');
            }
          });
        });
      }
    }
    if(window.innerWidth <= 991){
      if(document.querySelector('.section-contradirectional-slider') == null) overlay();
      singleCartDrawerClose();
      if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
        menuBurger.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          document.body.classList.toggle('open-menu');
          document.body.classList.remove('open-drawer','open-search','open-sort','open-filter', 'active-wishli-pro');    
        });
      });
    }else{
      overlay();
    }
    cartVariant();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      document.querySelector('.cartlist').setAttribute('data-count',cart_count);
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

document.addEventListener("input", function() {
  var cartSidebar = document.querySelector(".cart-sidebar");
  var discountInput = document.querySelector(".cd-discount-input");

  if (!cartSidebar || !discountInput) return;

  if (discountInput.value.trim() !== "") {
    cartSidebar.classList.add("has-active-discount");
  } else {
    cartSidebar.classList.remove("has-active-discount");
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var cartSidebar = document.querySelector(".cart-sidebar");
  var discountBadges = document.querySelector(".cd-discount-badges");

  if (cartSidebar && discountBadges) {
    cartSidebar.classList.add("has-active-discount");
  }
});
